module.exports = __webpack_public_path__ + "img/vagueIcon.27b7424b.png";